import React from 'react'
import {
  withStyles,
  WithStyles,
  DialogTitle as MuiDialogTitle,
  IconButton,
  Close as CloseIcon,
} from '@zn-material-ui'
import titleStyles from './styles/title'

export interface ITitleProps extends WithStyles<typeof titleStyles> {
  children: any
  onClose: () => void
  id?: string
}

const DialogTitle = ({ children, onClose, classes }: ITitleProps) => (
  <MuiDialogTitle disableTypography={true} className={classes.root}>
    <p>{children}</p>
    {onClose && (
      <IconButton
        aria-label="Close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    )}
  </MuiDialogTitle>
)

export default withStyles(titleStyles)(DialogTitle)
